/**
 * Copyright (c) 2022, ResMed Inc. All rights reserved.
 */

import AlertStyle from "../style/AlertStyle";
const _CloudwatchURL = `${process.env.REACT_APP_WEREWOLF_API_INVOKE_URL}/v1/cloudwatch/log`;

export default class HttpService {

    _OktaService;

    constructor(oktaAuth){
        this._OktaService = oktaAuth;
    }

    fetch(url){
        //Requires CORS now because GETs Authorization
        if(url.startsWith(process.env.REACT_APP_WEREWOLF_API_INVOKE_URL)){
            return fetch(url,{
                headers: new Headers({
                    'Authorization': "Basic " + this._OktaService?.accessToken.accessToken
                })
            });
        }else{
            return fetch(url);
        }
    }

    log(message){
        this.post(_CloudwatchURL, message);
    }

    post(url,message){
        let xhr = new XMLHttpRequest();
        xhr.open("POST", url);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.setRequestHeader("Authorization", "Basic " + this._OktaService.accessToken.accessToken);
        xhr.onerror = (e) => console.log("Error calling API: " + e);
        xhr.send(message);
    }

    async async_result(url,message,method){
        return (await fetch(url,{
            method: method,
            body: message,
            mode: 'cors',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization':'Basic ' + this._OktaService?.accessToken.accessToken
            })
        })).json()
    }

    /**
     * Creates a post request
     *
     * @param url         url to use for request
     * @param body        body of request
     * @param description description of request (used in alert message)
     * @param alert       alert function to call
     * @param refresh     refresh function to call on success
     */
     asyncPost(url, body, description, alert, refresh) {
        let xhr = new XMLHttpRequest();
        xhr.open("POST", url);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.setRequestHeader("Authorization", "Basic " + this._OktaService.accessToken.accessToken);
        xhr.onload = () => this.onSuccess(description, alert, refresh);
        xhr.onerror = () => this.onFail(description, alert);

        xhr.send(body);
    }

    /**
     * Function to call on promise success
     *
     * @param description description of request (used in alert message)
     * @param alert       alert function to call
     * @param refresh     refresh function to call on success
     */
    onSuccess(description, alert, refresh) {
        if (alert) {
            alert.success(AlertStyle.common(`${description} succeeded`));
        }

        if (refresh) {
            refresh();
        }

        this.log(`${description} succeeded`);
    }

    /**
     * Function to call on promise error
     *
     * @param description description of request (used in alert message)
     * @param alert       alert function to call
     */
    onFail(description, alert) {
        if (alert) {
            alert.error(AlertStyle.common(`${description} failed`));
        }

        this.log(`${description} failed`)
    }

    synchronousGetRequest(url) {
        const httpRequest = new XMLHttpRequest();
        httpRequest.open('GET', url, false);
        httpRequest.setRequestHeader('Content-Type', 'application/json');
        httpRequest.setRequestHeader('Authorization', 'Basic ' + this._OktaService.accessToken.accessToken);
        httpRequest.send();

        return httpRequest.responseText
    }
}